import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { reduxForm } from 'redux-form';

import { RootReducerStateT } from 'app/reducers/rootReducer';
import { hasFeature } from 'components/shared/featureFlag';

import { organizationActions } from '../actions/organization';
import {
  OrganizationDispatchPropsT,
  OrganizationFormValuesT,
  Organization as OrganizationImpl,
  OrganizationOwnPropsT,
  OrganizationStatePropsT,
} from '../components';
import { OrganizationPropsT } from '../components/Organization';
import { validateOrganizationForm } from '../components/utils';

const {
  organizationV2GetPresignedAvatarUrl,
  organizationV2Get,
  organizationV2Edit,
} = organizationActions;

const FORM_NAME = 'organizationForm';

const mapStateToProps = (
  state: RootReducerStateT,
  ownProps,
): OrganizationStatePropsT => {
  let organization = ownProps.organization;
  if (state.settings.organizationV2.organization?.id) {
    organization = state.settings.organizationV2.organization;
  }

  return {
    initialValues: {
      organization: {
        name: organization.name,
        timezone: organization.timezone,
      },
    },
    organization: organization,
    meta: state.settings.organizationV2.meta,
    hasTimezoneSetting: hasFeature(state, 'new-live-dashboard'),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): OrganizationDispatchPropsT => {
  return {
    getOrganizationData(organizationId) {
      dispatch({
        type: organizationV2Get.toString(),
        organizationId: organizationId,
      });
    },
    updateAvatar(file, organization) {
      dispatch({
        type: organizationV2GetPresignedAvatarUrl.toString(),
        file: file,
        organization: organization,
      });
    },
    editOrganization(id: string, payload) {
      dispatch({
        type: organizationV2Edit.toString(),
        id: id,
        payload: payload,
      });
    },
  };
};

const OrganizationForm = reduxForm<OrganizationFormValuesT, OrganizationPropsT>(
  {
    form: FORM_NAME,
    enableReinitialize: true,
    validate: validateOrganizationForm,
  },
)(OrganizationImpl);

const OrganizationFormConnected = connect<
  OrganizationOwnPropsT,
  OrganizationDispatchPropsT,
  OrganizationStatePropsT,
  RootReducerStateT
>(
  mapStateToProps,
  mapDispatchToProps,
)(OrganizationForm);

export { OrganizationFormConnected as Organization };
